import React, { useCallback, useState } from "react";
import { Search, SearchProps } from "./search";
import { useHistory } from "react-router-dom";
import { useMunicipalityHome } from "../../providers/municipality-home-provider";

interface SearchContainerProps {
  className?: string;
}

export const SearchContainer = ({ className }: SearchContainerProps) => {
  const [searchValue, setSearchValue] = useState<string>();
  let history = useHistory();
  const { municipioQuerySuffix } = useMunicipalityHome();

  const onClickSearch = useCallback(() => {
    if (!searchValue) return;
    history.push(
      `/search/${encodeURIComponent(searchValue)}${municipioQuerySuffix}`
    );
  }, [searchValue, history, municipioQuerySuffix]);

  const props: SearchProps = {
    onChangeText: setSearchValue,
    onClickSearch,
    className,
  };

  return <Search {...props} />;
};
